import { render } from "./FacturesFournisseurList.vue?vue&type=template&id=605c0e1f&scoped=true&ts=true"
import script from "./FacturesFournisseurList.vue?vue&type=script&lang=ts"
export * from "./FacturesFournisseurList.vue?vue&type=script&lang=ts"

import "./FacturesFournisseurList.vue?vue&type=style&index=0&id=605c0e1f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605c0e1f"]])

export default __exports__